import { render, staticRenderFns } from "./CarrierPauseBanner.vue?vue&type=template&id=640bca1e&scoped=true"
import script from "./CarrierPauseBanner.vue?vue&type=script&lang=js"
export * from "./CarrierPauseBanner.vue?vue&type=script&lang=js"
import style0 from "./CarrierPauseBanner.vue?vue&type=style&index=0&id=640bca1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bca1e",
  null
  
)

export default component.exports